"use strict";

module.exports = function (scope) {
	var buttonCreator = require("./button");
	var playerCreator = require("./player");
	var containerCreator = require("./container");
	return {
		button: buttonCreator(scope),
		player: playerCreator(scope),
		container: containerCreator(scope)
	};
};